import React from "react"
import { Col } from "react-bootstrap"

import { Loader } from "@googlemaps/js-api-loader"

function PropertyMaps({ property }) {
    var styles = [
        {
            stylers: [
                {
                    saturation: -80,
                },
            ],
        },
    ]

    const loader = new Loader({
        apiKey: process.env.GOOGLE_MAPS,
        version: "weekly",
        libraries: ["places"],
        nonce: "T4n23MXvZO",
    })

    const mapOptions = {
        center: {
            lat: parseFloat(property.location?.latitude),
            lng: parseFloat(property.location?.longitude),
        },
        zoom: 15,
        styles: styles,
    }

    loader
        .load()
        .then((google) => {
            const map = new google.maps.Map(
                document.getElementById("map"),
                mapOptions,
            )
            new google.maps.Marker({
                position: {
                    lat: parseFloat(property.location?.latitude),
                    lng: parseFloat(property.location?.longitude),
                },
                map: map,
            })
        })
        .catch((e) => {})

    return (
        <Col xs={12} className="px-0 mb-3">
            <div id="map" className="sp-map"></div>
        </Col>
    )
}

export default PropertyMaps
